import {Button, Dialog, Form, FormItem, Input, Row, Col, MessageBox, Message, Notification} from "element-ui";
import lang from "element-ui/lib/locale/lang/ru-RU";
import "./element-variables.scss";
import ClinicAppointment from "./ClinicAppointment";

import locale from 'element-ui/lib/locale'


export default {
  install(Vue) {
    locale.use(lang)
    Vue.component("clinic-appointment", ClinicAppointment);
    Vue.component(Button.name, Button);
    Vue.component(Dialog.name, Dialog);
    Vue.component(Input.name, Input);
    Vue.component(Form.name, Form);
    Vue.component(FormItem.name, FormItem);
    Vue.component(Row.name, Row);
    Vue.component(Col.name, Col);
    Vue.component(Message.name, Message);
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$notify = Notification;
    Vue.prototype.$message = Message;
  }
};
